import tearRewardsTable from "../../../../assets/tierRewardsTable.svg";
import BaseImage from "../../../../baseComponents/baseImage.js";
import WelcomeText from "../../../../components/WelcomeText.js";
import EnlargeOnClick from "../../../../utilComponents/EnlargeOnClick";
import useBootstrap from "../../../../customHooks/useBootstrap";
import MyRewardsCupons from "../../rewardsStack/fragments/MyRewardsCupons";
import BaseHeading from "../../../../baseComponents/baseHeading";
import { getters as userGetters } from "../../../../store/slices/userSlice";
import { useSelector } from "react-redux";
import Banner from "../../../../components/Banner.js";
import Giveaway from "../../../../components/Giveaway.js";

const MainPageMainContent = ({}) => {
  const { trashold, classes } = useBootstrap();

  //const cuponsCount = useSelector(userGetters.getCuponsCount);

  return (
    <div>
      <div className={`${classes.onOrAboveTrashold.show(true)}`}>
        <WelcomeText fontSize="2.2em" />
      </div>
      <br />
      <div className={`w-75 ${classes.onOrAboveTrashold.show(true)}`}>
        <EnlargeOnClick modalTitle="">
          <BaseImage
            buildSrcFromConnection={false}
            style={{ margin: "50px 0px 0px 0px" }}
            src={tearRewardsTable}
          />
        </EnlargeOnClick>
      </div>

      <div className={`w-100 ${classes.onOrAboveTrashold.show(false)}`}>
        <EnlargeOnClick modalTitle="" proportion={75}>
          <BaseImage
            buildSrcFromConnection={false}
            style={{ margin: "50px 0px 0px 0px" }}
            src={tearRewardsTable}
          />
        </EnlargeOnClick>
      </div>

      <br />
      {/* {cuponsCount > 0 &&
        <>
          <BaseHeading>cuponRewards</BaseHeading>
          <MyRewardsCupons />
        </>
      } */}

      <Giveaway />
      <Banner />
      <br />
    </div>
  );
};


export default MainPageMainContent;